import React from 'react';
interface CTAButtonProps {
  text: string;
  className?: string;
  href?: string;
  scarcity?: string;
}
export function CTAButton({
  text,
  className = '',
  href = '#',
  scarcity
}: CTAButtonProps) {
  return <div className="flex flex-col items-center" data-id="element-63">
      {scarcity && <div className="flex items-center mb-2 text-red-600 font-medium" data-id="element-64">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" viewBox="0 0 20 20" fill="currentColor" data-id="element-65">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" data-id="element-66" />
          </svg>
          {scarcity}
        </div>}
      <a href={href} className={`inline-block px-8 py-4 bg-gradient-to-r from-purple-500 to-teal-600 hover:from-purple-600 hover:to-teal-700 text-white font-medium rounded-lg shadow-md transition duration-300 text-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-opacity-50 text-center mx-auto ${className}`} data-id="element-67">
        {text}
      </a>
    </div>;
}